var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-intro"},[_c('h2',{staticClass:"heading-2",domProps:{"innerHTML":_vm._s(_vm.heading)}}),(_vm.body.length > 0)?_c('div',{staticClass:"intro",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }